<template>
  <div>
    <p class="mb-6 text-black-light-5" v-html="region.tagLine"></p>

    <ul class="grid grid-cols-4 gap-4 list-reset">
      <li v-for="destination in destinations" :key="destination.id">
        <div class="aspect-ratio-2/3">
          <a class="block" :href="destination.url">
            <img
              class="w-full h-full object-cover rounded"
              :src="getCloudinaryImage(destination.image)"
              :alt="destination.name"
            />

            <div class="card-text absolute">
              <h4
                class="font-medium text-white fs-20 pb-6"
                v-html="destination.name"
              ></h4>
            </div>
          </a>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { getCloudinaryUrl } from "../../helpers";

export default {
  props: ["region"],
  computed: {
    destinations() {
      return this.region.children || [];
    },
  },
  methods: {
    getCloudinaryImage(path){
      const origin = window.location.origin
      return getCloudinaryUrl(`${origin}${path}`, { width: 600 })
    }
  }
};
</script>

<style scoped>
.card-text {
  bottom: 0;
  left: 0;
  right: 0;
  text-align: center;
}
</style>
